import React, { useEffect, useState } from "react";
import Hoc from "../HOC/Hoc";
import TopHeading from "../../utils/TopHeading/TopHeading";
import AnimatedPage from "../animatedPage/AnimatedPage";
import AsyncDropdown from "../../utils/asyncDropdown/AsyncDropdown";
import { updatePanelistCategory, getPanelistCategory } from "./upgradeUser.API";
import {
  Stack,
  TextField,
  Paper,
  Button,
  Grid,
  Snackbar,
  InputAdornment,
  Alert
} from "@mui/material";

const UpgradeUser = () => {
  const [panelist, setPanelist] = useState(null);
  const [panelistIds, setPanelistIds] = useState(null);
  const [panelistEmails, setPanelistEmails] = useState(null);
  const [catgoryItems, setCatgoryItems] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = () => {
    if (!panelistIds || !selectedCategory) {
      setSnackbarMessage("All fields are required.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    const body = {
      categoryType: selectedCategory.id,
      panelists: {
        panelistId: panelistIds,
        email: panelistEmails,
      },
    };
    updatePanelistCategory(body)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setSnackbarOpen(true);
          setSnackbarMessage("Panelists upgraded successfully");
          setSnackbarSeverity("success");
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage("Something went wrong! Try again");
          setSnackbarSeverity("error");
        }
        handleCleanUp();
      })
      .catch((err) => {
        setSnackbarOpen(true);
        setSnackbarMessage("Something went wrong! Try again");
        setSnackbarSeverity("error");
         handleCleanUp();
      });
  };
  const handlePanelistChange = (e) => {
    let inputValue = e.target.value;
    let values = inputValue
      .split(/[\n,]+/)
      .map((val) => val.trim())
      .filter(Boolean);
    let panelistIds = values
      .filter((val) => !isNaN(val) && val !== "")
      .map(Number);
    let emails = values.filter((val) => isNaN(val) && val.includes("@"));
    setPanelistIds(panelistIds);
    setPanelistEmails(emails);
    setPanelist(values);
  };

  const handleCleanUp = () => {
    setPanelistIds([]);
    setPanelistEmails([]);
    setPanelist("");
    setSelectedCategory(null);
  };
  const handleCategoryDropDownChange = (value) => {
    setSelectedCategory(value)
  };

  useEffect(() => {
    getPanelistCategory().then((res) => {
      if (res.status === 200 && res.data.success) {
        const uniqueItems = res.data.data;
        setCatgoryItems(uniqueItems);
      } else {
        setCatgoryItems([])
      }
    }).catch((err) => {
      setCatgoryItems([])
    });
  }, []);
  return (
    <>
      <AnimatedPage>
        <TopHeading showButton={false} heading="Upgrade User Category" />
        <Paper sx={{ px: 2, py: 4, mx: 2, mb: 1 }} elevation={2}>
          <Stack spacing={6} alignItems="center">
            <Grid
              sx={{ px: 2, py: 1, mx: 2 }}
              container
              className="prioritySurveyForm"
            >
              <Grid sx={{ py: 3 }} container alignItems="center">
                <Grid sx={{ mx: 1 }} xs={12} sm={6} md={6}>
                  <AsyncDropdown
                    label={"Category"}
                    value={selectedCategory}
                    handleChange={(value) =>
                      handleCategoryDropDownChange(value)
                    }
                    objKey="categoryType"
                    options={catgoryItems}
                  />
                </Grid>
              </Grid>
              <Grid sx={{ py: 3 }} container alignItems="center">
                <Grid item sx={{ mx: 1 }} xs={12} sm={6} md={6}>
                  <TextField
                    type="text"
                    value={panelist || ""}
                    fullWidth
                    label="Panelists"
                    rows={5}
                    multiline
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    onChange={handlePanelistChange}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <Grid sx={{ py: 2 }} container alignItems="center">
                <Grid sx={{ mx: 1 }} xs={12} sm={2} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      </AnimatedPage>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity={
            snackbarSeverity === "success" ? undefined : snackbarSeverity
          }
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor:
              snackbarSeverity === "success" ? "#2196f3" : undefined, // Blue for success
            color: snackbarSeverity === "success" ? "#fff" : undefined, // White text for blue background
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export const UpgradePanelist = Hoc(UpgradeUser, { name: "" });
